// TODO: detect if menu items are slotted and add class to ul

import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'cwru-sub-nav-item',
  styleUrl: 'navigation.css',
  shadow: false,
})
export class SubNavItem {
  @Prop() href: string = '#';
  @Prop() text: string = 'Link';

  render() {
    return (
      <li class="submenu-item" role="menuitem">
        <a href={this.href}>{this.text}</a>
      </li>
    );
  }
}
